import { useCallback, useEffect, useRef, useState } from 'react';

/** Reveal the whole card after its real poster has decoded, including cached images/errors. */
export default function usePosterReveal(src, onRatio, unavailable = false) {
  const imageRef = useRef(null);
  const [settled, setSettled] = useState(null);
  const current = useRef(src); current.current = src;
  const report = useRef(onRatio); report.current = onRatio;
  const ready = !src || unavailable || settled?.src === src;
  const failed = unavailable || (settled?.src === src && !!settled?.failed);
  const onLoad = useCallback(async event => {
    const img = event?.currentTarget || imageRef.current;
    if (!img || !img.naturalWidth) return;
    const loadedSrc = src;
    report.current?.(img.naturalWidth / img.naturalHeight);
    try { if (img.decode) await img.decode(); } catch { /* The loaded image can still render if decode rejects. */ }
    if (current.current === loadedSrc) setSettled({ src: loadedSrc, failed: false });
  }, [src]);
  const onError = useCallback(() => setSettled({ src, failed: true }), [src]);
  useEffect(() => {
    const img = imageRef.current;
    if (img?.complete && img.naturalWidth) onLoad();
    else if (img?.complete && src) onError();
  }, [src, onLoad, onError]);
  return { imageRef, ready, failed, onLoad, onError };
}
